class DynamicRollover extends HTMLElement {
  constructor() {
    super()
    this.windowWidth = window.innerWidth
    this.navigation = this.querySelector(".dynamic-rollover__navigation")
    this.navItems = this.querySelectorAll(".dynamic-rollover__navigation-item")
    this.tabItems = this.querySelectorAll(".dynamic-rollover__block")
    this.touchstartX = 0
    this.touchendX = 0
    this.touchstartY = 0
    this.touchendY = 0

    this.navItems.forEach((item, index) => {
      item.addEventListener("click", this.setActive.bind(this))
      item.addEventListener("click", this.mobileTabNavPosition.bind(this, index))
    })

    this._setupEventListeners()
  }

  _setupEventListeners() {
    this.addEventListener('touchstart', e => {
      this.touchstartX = e.changedTouches[0].screenX
      this.touchstartY = e.changedTouches[0].screenY
    })

    this.addEventListener('touchend', e => {
      this.touchendX = e.changedTouches[0].screenX
      this.touchendY = e.changedTouches[0].screenY
      this.swipe()
    })
  }

  swipe() {
    if (
      Math.abs(this.touchendX - this.touchstartX) < 100 ||
      Math.abs(this.touchendY - this.touchstartY) > 50 ||
      this.windowWidth >= 750
    ) {
      return
    }

    const isSwipeLeft = this.touchendX < this.touchstartX

    let activeIndex = null
    for (let i = 0; i < this.navItems.length; i++) {
      const currentItem = this.navItems[i]
      if (currentItem.classList.contains("active")) {
        activeIndex = i
      }
    }

    // if at last item and swipe left OR at first item and swipe right, do nothing
    if (
      activeIndex === null ||
      (isSwipeLeft && activeIndex === this.navItems.length - 1) ||
      (!isSwipeLeft && activeIndex === 0)
    ) {
      return
    }

    const oldIndex = activeIndex
    const oldActiveItem = this.navItems[activeIndex]
    const newIndex = isSwipeLeft ? (activeIndex + 1) : (activeIndex - 1)
    const newActiveItem = this.navItems[newIndex]
    const newActiveItemData = newActiveItem.dataset.target

    this.navItems.forEach((item) => item.classList.remove("active"))
    this.tabItems.forEach((item) => item.classList.remove("transition"))
    newActiveItem.classList.add("active")

    setTimeout(() => {
      this.tabItems.forEach((item) => item.classList.remove("active"))
      this.querySelector(`.${newActiveItemData}`).classList.add("active")
    }, 410)

    setTimeout(() => {
      this.querySelector(`.${newActiveItemData}`).classList.add("transition")
    }, 600)

    // --------------------------------------

    let navWidth = 0
    let previousItemWidth = 0

    for (let i = 0; i < this.navItems.length; i++) {
      navWidth += (this.navItems[i].scrollWidth + 40)
    }
    for (let i = 0; i < newIndex; i++) {
      previousItemWidth += (this.navItems[i].scrollWidth + 40)
    }
    const value = newIndex > 0
      ? previousItemWidth + (newActiveItem.scrollWidth / 2) - 40
      : 20

    this.navigation.style.transform = `translateX(-${Math.abs(value)}px)`
  }

  setActive(event) {
    const target = event.target
    const targetData = target.dataset.target
    this.navItems.forEach((item) => {
      item.classList.remove("active")
    })
    this.tabItems.forEach((item) => {
      item.classList.remove("transition")
    })
    target.classList.add("active")

    setTimeout(() => {
      this.tabItems.forEach((item) => {
        item.classList.remove("active")
      })
      this.querySelector(`.${targetData}`).classList.add("active")
    }, 410)

    setTimeout(() => {
      this.querySelector(`.${targetData}`).classList.add("transition")
    }, 600)
  }

  mobileTabNavPosition(index, event) {
    let navWidth = 0
    let previousItemWidth = 0
    const itemIndex = index
    const item = event.target
    const itemWidth = item.scrollWidth
    const navItems = [...this.navItems]

    const setMobileNavPosition = () => {
      if (this.windowWidth < 750) {
        // console.log('navWidth before loop', navWidth)
        for (let i = 0; i < navItems.length; i++) {
          navWidth += (navItems[i].scrollWidth + 40)
          // console.log('navWidth after each rd', navWidth)
        }
        for (let i = 0; i < itemIndex; i++) { previousItemWidth += (navItems[i].scrollWidth + 40) }
        // console.log('navWidth', navWidth);
        // console.log('previousItemWidth', previousItemWidth);
        // console.log('itemWidth', itemWidth);
        const value = itemIndex > 0 ? previousItemWidth + (itemWidth / 2) - 40 : 20
        // console.log('value', value);


        this.navigation.style.transform = `translateX(-${Math.abs(value)}px)`
        navWidth = 0
        previousItemWidth = 0
      }
    }

    setMobileNavPosition()
    window.addEventListener("resize", setMobileNavPosition)
  }
}

customElements.define("dynamic-rollover", DynamicRollover)
